<template>
  <div id="system-manage-authority-detail">
    <div class="relative ipub-h2 mar-b-20">
      Set Up Authority
      <div class="right-option ipub-p1">
        <ipub-button style="width:100px"
                     type="primary"
                     @click="reset">
          Reset
        </ipub-button>
        <ipub-button style="width:100px"
                     type="primary"
                     @click="save">
          Save
        </ipub-button>
      </div>
    </div>
    <!-- <div class="ipub-p4 font-color">
      Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem.
    </div> -->
    <div class="page-content">
      <div class="manage-authority-detail-item"
           v-for="(item, index) in length"
           :key="'manage-authority-detail-item'+index">
        <ipub-radio :checked="item.selectAll"
                    @change="changeSelectAll(index, !item.selectAll)"
                    class="mar-b-10 fw-bd">Select All</ipub-radio>
        <div class="manage-authority-detail-item__content">
          <div :class="['manage-authority-detail-item__content__item',item.select === num?'active':'']"
               v-for="(val, num) in dataSource[index]"
               :key="val.id||val.name">
            <ipub-radio @change="changeAuthority(val.authorityId, index)"
                        :checked="authorityIds.includes(val.authorityId)"
                        :value="val.authorityId">
              <a @click.stop
                 style="display: inline-block;width: 160px;white-space: normal"
                 @click="openChildren(index, num)">
                {{val.name}}
              </a>
              <ipub-icon v-if="val.children&&val.children.length"
                         :class="['mar-l-10 rotate rotate-270', item.select === num?'link-color':'']"
                         type="iconArrow" />
            </ipub-radio>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
